import { useZoomToCenter as v } from "./index.es180.js";
import { useFitBounds as M, getBBoxByFeatures as h } from "./index.es181.js";
import { usePLMapboxLegendActions as w } from "./index.es182.js";
import { useAddPopup as G } from "./index.es49.js";
import { useRemovePopup as H } from "./index.es183.js";
import { useAddPinLayer as O } from "./index.es184.js";
import { useAddPolygonLayer as D } from "./index.es185.js";
import { useHoverTooltip as F } from "./index.es186.js";
import { useOnPLMapboxLoad as R } from "./index.es187.js";
import { useUpdateLayer as E } from "./index.es188.js";
import { useDeleteLayers as N } from "./index.es189.js";
import { useGetLayerIds as z } from "./index.es190.js";
import { useOnAllLayersLoaded as U } from "./index.es191.js";
import { useAddLineLayer as Z } from "./index.es192.js";
import { useAddPinNumberedLayer as j } from "./index.es193.js";
import { useOnDebouncedViewstateChange as k } from "./index.es194.js";
import { useGetViewstate as q } from "./index.es195.js";
import { useGetBasemap as J } from "./index.es196.js";
import { useOnBasemapChange as K } from "./index.es197.js";
import { useAddRegionalTileLayer as Q } from "./index.es198.js";
import { getCircleFeature as W } from "./index.es199.js";
import { useAddStaticVTVLayer as X } from "./index.es200.js";
import { useAddStaticTradeAreaLayer as Y } from "./index.es201.js";
import { useSetExternalLoadingStatus as _ } from "./index.es202.js";
const Be = () => {
  const e = v(), o = M(), { setLegendItems: t, addLegendItem: r, removeLegendItem: a, updateLegendItem: s } = w(), n = O(), d = D(), m = Z(), i = G(), p = H(), { generateTooltip: u, clearHoverTooltip: L } = F(), c = R(), f = k(), y = q(), g = K(), l = J(), A = E(), P = N(), T = z(), S = U(), x = j(), B = Q(), b = X(), { addStaticHexagonTradeArea: V, addStaticHeatMapGradientTradeArea: C } = Y(), I = _();
  return {
    zoomToCenter: e,
    fitBounds: o,
    getBBoxByFeatures: h,
    setLegendItems: t,
    addLegendItem: r,
    removeLegendItem: a,
    updateLegendItem: s,
    addPopup: i,
    removePopup: p,
    addPinLayer: n,
    addPinNumberedLayer: x,
    addPolygonLayer: d,
    addLineLayer: m,
    generateTooltip: u,
    clearHoverTooltip: L,
    onPLMapboxLoad: c,
    onDebouncedViewStateChange: f,
    getViewState: y,
    onBasemapChange: g,
    getBasemap: l,
    updateLayer: A,
    deleteLayers: P,
    getLayerIds: T,
    onAllLayersLoaded: S,
    addRegionalTileLayer: B,
    getCircleFeature: W,
    addStaticVTVLayer: b,
    addStaticHexagonTradeArea: V,
    addStaticHeatMapGradientTradeArea: C,
    setExternalLoadingStatus: I
  };
};
export {
  Be as usePLMapbox
};
//# sourceMappingURL=index.es174.js.map
